<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Email Marketing</li>
  </app-tabs>
  <app-email-campaign-template-index class="flex-control flex-column" [hidden]="tabs_service.is_active()" [campaign_type]="'email'"></app-email-campaign-template-index>
</div>
